"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatingInventoryHistoryEventTypes = exports.FloatingInventoryStatus = exports.FloatingInventoryOwnerType = exports.FloatingInventoryCustody = exports.OWNERSHIP_ORIGIN = void 0;
var OWNERSHIP_ORIGIN;
(function (OWNERSHIP_ORIGIN) {
    OWNERSHIP_ORIGIN[OWNERSHIP_ORIGIN["DRIVER_API"] = 1] = "DRIVER_API";
    OWNERSHIP_ORIGIN[OWNERSHIP_ORIGIN["WEB_API"] = 2] = "WEB_API";
    OWNERSHIP_ORIGIN[OWNERSHIP_ORIGIN["SERVICES_API"] = 3] = "SERVICES_API";
    OWNERSHIP_ORIGIN[OWNERSHIP_ORIGIN["FLOATING_INVENTORY_APP"] = 4] = "FLOATING_INVENTORY_APP";
})(OWNERSHIP_ORIGIN || (exports.OWNERSHIP_ORIGIN = OWNERSHIP_ORIGIN = {}));
var FloatingInventoryCustody;
(function (FloatingInventoryCustody) {
    FloatingInventoryCustody[FloatingInventoryCustody["UNKNOWN"] = 0] = "UNKNOWN";
    FloatingInventoryCustody[FloatingInventoryCustody["DISPATCHER"] = 1] = "DISPATCHER";
    FloatingInventoryCustody[FloatingInventoryCustody["DRIVER"] = 2] = "DRIVER";
    FloatingInventoryCustody[FloatingInventoryCustody["CUSTOMER"] = 3] = "CUSTOMER";
    FloatingInventoryCustody[FloatingInventoryCustody["MISSING"] = 4] = "MISSING";
    FloatingInventoryCustody[FloatingInventoryCustody["VEHICLE"] = 5] = "VEHICLE";
})(FloatingInventoryCustody || (exports.FloatingInventoryCustody = FloatingInventoryCustody = {}));
var FloatingInventoryOwnerType;
(function (FloatingInventoryOwnerType) {
    FloatingInventoryOwnerType["DRIVER"] = "driver";
    FloatingInventoryOwnerType["TEAM"] = "team";
    FloatingInventoryOwnerType["NONE"] = "none";
})(FloatingInventoryOwnerType || (exports.FloatingInventoryOwnerType = FloatingInventoryOwnerType = {}));
var FloatingInventoryStatus;
(function (FloatingInventoryStatus) {
    FloatingInventoryStatus["AVAILABLE"] = "available";
    FloatingInventoryStatus["USED"] = "used";
    FloatingInventoryStatus["MISSING"] = "missing";
})(FloatingInventoryStatus || (exports.FloatingInventoryStatus = FloatingInventoryStatus = {}));
var FloatingInventoryHistoryEventTypes;
(function (FloatingInventoryHistoryEventTypes) {
    FloatingInventoryHistoryEventTypes["CREATED"] = "created";
    FloatingInventoryHistoryEventTypes["USER_ASSIGNED"] = "user_assigned";
    FloatingInventoryHistoryEventTypes["TEAM_ASSIGNED"] = "team_assigned";
    FloatingInventoryHistoryEventTypes["REPORTED_MISSING"] = "reported_missing";
    FloatingInventoryHistoryEventTypes["ITEM_FOUND"] = "item_found";
    FloatingInventoryHistoryEventTypes["MASS_CUSTODY_CHANGE"] = "mass_custody_change";
})(FloatingInventoryHistoryEventTypes || (exports.FloatingInventoryHistoryEventTypes = FloatingInventoryHistoryEventTypes = {}));
//# sourceMappingURL=floating_inventory.js.map